export default __webpack_public_path__ + "static/media/mg-girl.29e4634e.webp";